const strings = {
  APARTMENT_NUMBER: 'Lägenhetsnummer',
  EMAIL: 'Email',
  JANITOR: 'Får felanmälningar',
  ADMIN: 'Administratör',
  NEW_USER: 'Ny användare',
  NEW_USER_INFO:
    'Vill du ladda ner manualen och ge den till den nya användaren eller skapa kontot själv?',
  CREATE_NEW_USER: 'Skapa själv',
  CANCEL: 'Avbryt',
  DELETE_USER: 'Ta bort användare',
  DELETE_USER_INFO:
    'Är du säker på att du vill ta bort användaren? Detta kan inte göras ogjort.',
  YES: 'Ja',
  NO: 'Nej',
  MANAGE_APARTMENTS: 'Hantera lägenheter',
  BOOK_OR_UNBOOK_LAUNDRY_TIME: 'Boka eller avboka en tvättid',
  CODE: 'Kod',
  RESET: 'Återställ (vid utflytt)',
  RESET_APARTMENT: 'Återställ lägenhet',
  RESET_APARTMENT_INFO:
    'Är du säker på att du vill återställa lägenheten? Detta bör endast göras vid utflytt, alla användare som tillhör lägenheten kommer att försvinna och en ny kod kommer genereras.',
  SHOW_USERS: 'Visa användare',
  HIDE_USERS: 'Dölj användare',
  NO_USERS: 'Inga användare',
  ADD_USER_TO_APARTMENT: 'Lägg till en användare på lägenhet',
  DOWNLOAD_MANUAL: 'Ladda ner manual för att koppla upp användare på lägenhet',
  DOWNLOAD_ALL_MANUALS: 'Ladda ned pdf för alla lägenheter',
  DOWNLOADING_MANUALS: 'Genererar PDF...',
  DOWNLOAD_ERROR: 'Kunde inte ladda ner PDF. Försök igen senare.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/UserTable/strings.js